import React from 'react';
import PropTypes from 'prop-types';
import Container from './css';

const InlineTextLink = ({ children, ...rest }) => (
  <Container {...rest}>
    {children}
  </Container>
);

InlineTextLink.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InlineTextLink;
